import axios from 'axios';

const API_BASE =
    process.env.REACT_APP_API_BASE ||
    (window.location.port === '3000' ? 'http://localhost:3001' : '');

export const fetchNormalDistributionFilters = async ({ selectedFamilies = [] } = {}) => {
    const params = {
        selectedFamilies: selectedFamilies.join(',') || undefined,
    };
    const [stepNumbersResponse, ateSwVersionsResponse, testspecsResponse] = await Promise.all([
        axios.get(`${API_BASE}/api/normal-distribution-step-numbers`, { params }),
        axios.get(`${API_BASE}/api/ate-sw-versions`),
        axios.get(`${API_BASE}/api/testspecs`),
    ]);

    return {
        stepNumbers: stepNumbersResponse.data || [],
        ateSwVersions: (ateSwVersionsResponse.data || []).map((item) => item.AteSwVersion),
        testspecs: (testspecsResponse.data || []).map((item) => item.Testspec),
    };
};

export const fetchNormalDistribution = async ({
    selectedStepNumber,
    startDate,
    endDate,
    selectedAteSwVersion,
    selectedTestspec,
    lsl,
    usl,
    selectedFamilies = [],
}) => {
    const response = await axios.get(`${API_BASE}/api/normal-distribution`, {
        params: {
            stepNumber: selectedStepNumber,
            startDate: startDate ? startDate.toISOString() : undefined,
            endDate: endDate ? endDate.toISOString() : undefined,
            ateSwVersion: selectedAteSwVersion || undefined,
            Testspec: selectedTestspec || undefined,
            lsl: lsl || undefined,
            usl: usl || undefined,
            selectedFamilies: selectedFamilies.join(',') || undefined,
        },
    });

    return response.data;
};
